import { Injectable } from '@angular/core';
import { AuthorService } from './author.service';
import { HttpClient } from '../../../node_modules/@angular/common/http';
import { Observable } from '../../../node_modules/rxjs';
import { ProjectsService } from './projects.service';
import { NavController } from '../../../node_modules/@ionic/angular';
import { AssetInScene } from '../models/AssetInScene';
// import { SceneBackground } from '../models/SceneBackground';
import { Scene } from '../models/Scene';

@Injectable({
  providedIn: 'root'
})
export class PreviewService {


  public areAnnotationsEnabled = true;
  public wereChangesMade = false;

  public assetsInScene: AssetInScene[] = [];
  public scenes: Scene[] = [];
  // public sceneBackgrounds: SceneBackground[] = [];
  public sceneIndex: number;
  public skyID: string;

  constructor(
    public authorService: AuthorService,
    public httpClient: HttpClient,
    public projectService: ProjectsService,
    public navController: NavController
  ) {

  }

  getCurrentScene(): Scene {
    return this.scenes.find(s => s.sceneId == this.sceneIndex);
  }

  setScene(i) {
    this.sceneIndex = i;
    this.updateSky();
  }

  setSceneIndex(sceneId) {
    this.sceneIndex = this.scenes.find(s => s.sceneId == sceneId).sceneId;
    document.querySelector('#scene-index-range').setAttribute('value', this.sceneIndex);
  }

  checkScenes(sceneId): boolean {
    if (this.scenes.filter(x => x.sceneId == sceneId && x.active).length == 0) {
      return false;
    }
    else {
      return true;
    }
  }

  // setPreviewScenes(){
  //  this.scenes = [];
  // this.sceneBackgrounds = [];
  // this.scenes = this.authorService.scenes.filter(s => s.active == true);
  // this.scenes.forEach(scene => {
  //   this.sceneBackgrounds.push(this.authorService.sceneBackgrounds.filter(s => s.sceneId == scene.sceneId)[0]);
  // })
  //  }

  // setSceneTitle(sceneTitle){
  //   this.currentSceneTitle = sceneTitle;
  // }

  updateSky() {
    this.skyID = "#preview-pano-" + this.sceneIndex;
  }

}